import React, { useEffect, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import StoryblokClient from 'storyblok-js-client';
import SbEditable from 'storyblok-react';

const Storyblok = new StoryblokClient({
  accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
  cache: {
    clear: 'auto',
    type: 'memory',
  },
});
export default function ResourcesContainer(props) {
  return (
    <>
      <SbEditable
        content={
          props.allcontent && props.allcontent.body && props.allcontent.body[0]
            ? props.allcontent.body[0]
            : null
        }
      >
        <section
          className="center_container lg:pt-24 "
          style={{
            background: '#FFF',
          }}
        >
          <div className="container">
            <div className="row w-full resp-ters" style={{ margin: 'auto' }}>
              <div
                className="about__text w-full  px-10 lg:px-20"
                style={{ paddingTop: 25 }}
              >
                <div>
                  <h1 className="text-center">
                    <span className="font-light ">
                      {props.allcontent && props.allcontent.title
                        ? props.allcontent.title
                        : 'Resources'}
                    </span>
                  </h1>
                </div>
                <div className="wrap-line"></div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: `${Storyblok.richTextResolver.render(
                      props.allcontent &&
                        props.allcontent.body &&
                        props.allcontent.body[0] &&
                        props.allcontent.body[0].long_text,
                    )}`,
                  }}
                />
              </div>
            </div>
          </div>
        </section>
      </SbEditable>
    </>
  );
}
